/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import GetCustomerOrderDetails from '../services/GetCustomerOrderDetails';
import GetCustomerOrderInformation from '../services/GetCustomerOrderInformation';
import GetCustomerOrderById from '../services/GetCustomerOrderById'
import OrderInformationView from '../views/OrderInformationView';

export default async function loadOrderInformationView(orderDetails) {
  const services = [
    GetCustomerOrderDetails(orderDetails.orderId),
    GetCustomerOrderInformation(orderDetails.orderId),
    GetCustomerOrderById(orderDetails.orderId)
  ]

  const [order, orderTotals, orderInfo] = await Promise.all(services);

  const newContractValues = [
    {
      id: null,
      name: ''
    },
    {
      id: 0,
      name: 'Replacement'
    },
    {
      id: 1,
      name: 'New'
    },
    {
      id: 2,
      name: 'Both'
    }
  ];
  return new OrderInformationView({
    model: new Backbone.Model({
      order,
      orderTotals,
      orderInfo,
      newContractValues,
      editable: orderDetails.editable,
      showValidation: orderDetails.showValidation
    })
  });
}
